// PRE RMA CSB — Interface publique inchangée (mêmes noms, mêmes types,
// mêmes valeurs) — toutes les valeurs viennent désormais de UN SEUL
// endroit : rules.config.ts. Ce fichier ne fait plus que ré-exporter, pour
// que rien de ce qui importe depuis 'constants.ts' n'ait à changer.
//
// Pour modifier une règle (diagnostics, TDR, traitements, seuils d'âge) :
// éditer rules.config.ts UNIQUEMENT.

import { RULES } from './rules.config.ts';
export type { Genre, AgeUnite, TdrResultat, DiagnosticRef } from './rules.config.ts';
export { RULES } from './rules.config.ts';

export const TDR_POSITIFS = RULES.tdr.positifs;
export const DIAGNOSTICS_REF = RULES.diagnostics;
/** Diagnostics proposés à la saisie, dans l'ordre officiel du RMA (hors anciens codes). */
export const DIAGNOSTICS_SELECTIONNABLES = RULES.diagnostics.filter((d) => !d.legacy);
/** Affichés par défaut ; les autres (DIAGNOSTICS_MASQUES) apparaissent avec le bouton « + ». */
export const DIAGNOSTICS_COURANTS = DIAGNOSTICS_SELECTIONNABLES.filter((d) => d.courant);
export const DIAGNOSTICS_MASQUES = DIAGNOSTICS_SELECTIONNABLES.filter((d) => !d.courant);
export const DIAGNOSTICS_PALUDISME = RULES.diagnosticsPaludisme;
export const TRAITEMENT_AUTORISE = RULES.traitementAutorise;

export const AGE_JOURS_1_AN = RULES.age.seuils.unAn;
export const AGE_JOURS_5_ANS = RULES.age.seuils.cinqAns;
export const AGE_JOURS_18_ANS = RULES.age.seuils.dixHuitAns;
